document.addEventListener("DOMContentLoaded", () => {
  const URL_API = "https://back-ecommerce.sise.edu.pe";
  //const URL_API = "https://dev-ecommerse.sise.edu.pe";
  let modalData = null;
  let selectedKCGroup = null;
  
  const modal = document.getElementById("modalModalidad");
  const optionsContainer = document.getElementById("modalidad-options-container");
  const continueBtn = document.querySelector(".continue-btn");
  
  document.addEventListener('modalidadSelected', (e) => {
    selectedKCGroup = e.detail.kcGroup;
    continueBtn.disabled = false;
  });

  document.addEventListener('cart:refresh', () => {
    resetModalData();
  });

  function resetModalData() {
    modalData = null;
    selectedKCGroup = null;
    if (optionsContainer) optionsContainer.innerHTML = '';
    if (continueBtn) continueBtn.disabled = true;
  }

  function closeModal() {
    if (modal) modal.style.display = 'none';
    selectedKCGroup = null;
  }
  
  window.showModalidadModal = async (productId) => {
    resetModalData();

    if (!window.customerLoggedIn) {
      alert("Necesitas primero registrarte para poder realizar una venta.");
      window.location.href = "/account/login";
      return;
    } 
    
    document.getElementById("loading-container").style.display = "flex";
    
    try {
      modalData = null;
      
      const payload = {
        INSTITUTION: "SISE",
        ACAD_CAREER: "VIRT",
        STRM: "2207",
        ACAD_PROG: productId,
        CAMPUS: "VIRTU" //STABE
      };
      
      const response = await fetch(`${URL_API}/api/peoplesoft/get-groups`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      
      if (!response.ok) throw new Error("Error al obtener modalidades");
      modalData = await response.json();
      
      renderModalOptions(modalData.data);
      if (modal) modal.style.display = 'flex';
      
    } catch (err) {
      console.error(err);
      if (optionsContainer) {
        optionsContainer.innerHTML = '<p>Error al cargar las modalidades. Por favor intenta nuevamente.</p>';
      }
    } finally {
      document.getElementById("loading-container").style.display = "none";
    }
  };

  function renderModalOptions(grupos) {
    if (!optionsContainer) return;
  
    optionsContainer.innerHTML = '';
  
    if (!grupos || Object.keys(grupos).length === 0) {
      optionsContainer.innerHTML = `
        <div class="no-horarios-message">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24" height="24">
            <path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/>
          </svg>
          <p>Actualmente no hay ningún horario disponible.</p>
        </div>
      `;
      return;
    }   
    
    Object.entries(grupos).forEach(([kc_grupo, grupoData]) => {

      const diasNombres = grupoData.dias.map(dia => {
        const diasMap = {
          'Lun': 'Lunes',
          'Mar': 'Martes',
          'Mié': 'Miércoles',
          'Jue': 'Jueves',
          'Vie': 'Viernes',
          'Sáb': 'Sábado',
          'Dom': 'Domingo'
        };
        return diasMap[dia] || dia;
      }).join(' y ');

      const horarioTexto = grupoData.horario.join(', ');

      const optionElement = document.createElement('div');
      optionElement.className = 'modalidad-option';
      optionElement.dataset.value = kc_grupo;
      optionElement.dataset.descripcion = grupoData.descr_long;
      
      optionElement.innerHTML = `
        <div class="modalidad-info">
          <div class="title-option-container">
            <p class="title-option">Inicio ${grupoData.fecha_inicio}</p>
          </div>
          <div class="caract-option-container">
            <div class="caract-option-div">
              <span class="icon-modal"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M528 320C528 434.9 434.9 528 320 528C205.1 528 112 434.9 112 320C112 205.1 205.1 112 320 112C434.9 112 528 205.1 528 320zM64 320C64 461.4 178.6 576 320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320zM296 184L296 320C296 328 300 335.5 306.7 340L402.7 404C413.7 411.4 428.6 408.4 436 397.3C443.4 386.2 440.4 371.4 429.3 364L344 307.2L344 184C344 170.7 333.3 160 320 160C306.7 160 296 170.7 296 184z"/></svg></span>
              <p class="caract-option"><b>Duración:</b> ${grupoData.duracion}</p>
            </div>
            <div class="caract-option-div">
              <span class="icon-modal"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M216 64C229.3 64 240 74.7 240 88L240 128L400 128L400 88C400 74.7 410.7 64 424 64C437.3 64 448 74.7 448 88L448 128L480 128C515.3 128 544 156.7 544 192L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 192C96 156.7 124.7 128 160 128L192 128L192 88C192 74.7 202.7 64 216 64zM216 176L160 176C151.2 176 144 183.2 144 192L144 240L496 240L496 192C496 183.2 488.8 176 480 176L216 176zM144 288L144 480C144 488.8 151.2 496 160 496L480 496C488.8 496 496 488.8 496 480L496 288L144 288z"/></svg></span>
              <p class="caract-option"><b>Horarios:</b> ${diasNombres} de ${grupoData.hora}.</p>
            </div>
          </div>
        </div>
        <input type="radio" name="modalidad" class="modalidad-checkbox" value="${grupoData.kc_grupo}">
      `;
      
      optionElement.addEventListener('click', function() {
        document.querySelectorAll('.modalidad-option').forEach(opt => {
          opt.classList.remove('selected');
        });
        
        this.classList.add('selected');
        this.querySelector('.modalidad-checkbox').checked = true;
        
        document.dispatchEvent(new CustomEvent('modalidadSelected', {
          detail: {
            kcGroup: grupoData.kc_grupo,
            description: grupoData.descr_long
          }
        }));
      });
      
      optionsContainer.appendChild(optionElement);
    });
  }
  
  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        closeModal();
      }
    });
  }

  if (continueBtn) {
    continueBtn.addEventListener('click', () => {
      if (selectedKCGroup) {
        closeModal();
      }
    });
  }
});